









import { Vue, Prop, Component } from 'vue-property-decorator';
import { IEId } from '@signing-page/signing/types/eid';

@Component
export default class BankIdOption extends Vue {
  @Prop() option: IEId;
  @Prop({ default: false }) hoverColor: boolean;
  @Prop({ default: false }) disableClick: boolean;

  select() {
    if (!this.disableClick) {
      this.$emit('select', this.option);
    }
  }
}
